import { render, staticRenderFns } from "./TagChips.vue?vue&type=template&id=591fe268&scoped=true&"
import script from "./TagChips.vue?vue&type=script&lang=js&"
export * from "./TagChips.vue?vue&type=script&lang=js&"
import style0 from "./TagChips.vue?vue&type=style&index=0&id=591fe268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591fe268",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
